import type { PropsWithChildren } from 'react';

export const CommunicationInputWrapper = ({ children }: PropsWithChildren) => (
	<div className="flex flex-col gap-1 flex-wrap [ md:flex-row ]">
		{children}
	</div>
);
